import { Suspense, lazy } from "react";
import { Navigate, useRoutes, useLocation } from "react-router-dom";
// loadibng components
import LoadingScreen from "./../components/LoadingScreen";
import AuthGuard from "../guards/AuthGuard";
import Address from "./../pages/dashboard/CustomerBasicInfo";

const Loadable = (Component) => (props) => {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const { pathname } = useLocation();

  return (
    <Suspense
      fallback={<LoadingScreen isDashboard={pathname.includes("/dashboard")} />}
    >
      <Component {...props} />
      {/* <LoadingScreen isDashboard={pathname.includes("/dashboard")} /> */}
    </Suspense>
  );
};

//customer quote request
const CustomerQuotations = Loadable(
  lazy(() => import("./../pages/customer/Quotes/MyQuotations"))
);
// Order details
const OrdersPage = Loadable(lazy(() => import("../pages/Orders/OrdersPage")));
const OrderDetails = Loadable(lazy(() => import("../pages/Orders/OrderDetails")));

export const customerRoutes = [
  {
    path: "my-quotations",
    element: (
      <AuthGuard>
        <CustomerQuotations />
      </AuthGuard>
    ),
  },
  {
    path: "address",
    element: (
      <AuthGuard>
        <Address />
      </AuthGuard>
    ),
  },
  {
    path: "orders",
    element: (
      <AuthGuard>
        <OrdersPage />
      </AuthGuard>
    )
  },
  {
    path: "orders/:id",
    element: (
      <AuthGuard>
        <OrderDetails />
      </AuthGuard>
    )
  },
  // {
  //   path: "editAddress",
  //   element: (
  //     <AuthGuard>
  //       <EditAddress />
  //     </AuthGuard>
  //   ),
  // },
];
